import { fetchRecentSearches } from 'actions/SearchActions'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { useEffect } from 'react'

function useRecentSearches(): Array<App.FullRecentSearch> {
  const dispatch = useAppDispatch()

  const recentSearches = useAppSelector(state => state.auth.recentSearches)
  const memberId = useAppSelector(state => state.auth.account.memberId)
  const domainUserId = useAppSelector(state => state.auth.domainUserId)

  useEffect(() => {
    dispatch(fetchRecentSearches())
  }, [dispatch, domainUserId, memberId])

  return recentSearches
}

export default useRecentSearches
